import React from 'react';
import { Grid, Chip, Typography } from '@mui/material';
import { FaTractor, FaHelicopter, FaTrailer, FaCarSide, FaMotorcycle } from 'react-icons/fa';
import { RiTruckFill } from 'react-icons/ri';
import { GiTruck, GiBus } from 'react-icons/gi';
import colors from '../../../styles/colors';

interface Props {
  user: any;
  values: Record<string, any>;
  addProduct: (id: string) => void;
  colheitadeira: string;
  colheitadeiraCinza: string;
}

const productOptions = [
  { id: '1', label: 'Trator', icon: <FaTractor /> },
  { id: '2', label: 'Helicóptero', icon: <FaHelicopter /> },
  { id: '3', label: 'Semirreboque', icon: <FaTrailer /> },
  { id: '4', label: 'Carroceria', icon: <RiTruckFill /> },
  {
    id: '5',
    label: 'Caminhão e Ônibus',
    icon: (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <GiTruck />
        <GiBus />
      </div>
    ),
  },
  { id: '6', label: 'Colheitadeira' }, 
  {
    id: '7',
    label: 'LEVES (0km)',
    icon: (
      <><FaMotorcycle /><FaCarSide/></>
    ),
  },
];

export const ProductChips: React.FC<Props> = ({ user, values, addProduct, colheitadeira, colheitadeiraCinza }) => {
  const isSelected = (id: string) => values.products.includes(id);
  const canShow = (id: string) => user?.is_staff || user?.products?.includes(id);

  return (
    <Grid item md={12} xs={12}>
      <Typography variant="body1">Produtos</Typography>
      <Grid
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          flexWrap: 'wrap',
        }}
      >
        {productOptions.map((product) => {
          if (!canShow(product.id)) return null;

          const selected = isSelected(product.id);

          const icon =
            product.id === '6' ? (
              <img
                width="18"
                height="18"
                src={selected ? colheitadeira : colheitadeiraCinza}
                alt="harvester"
              />
            ) : (
              product.icon
            );

          return (
            <Chip
              key={product.id}
              sx={{
                marginX: 1,
                color: selected ? colors.IceWhite : colors.DarkerGray,
              }}
              icon={icon as React.ReactElement}
              label={product.label}
              color={selected ? 'primary' : 'default'}
              onClick={() => addProduct(product.id)}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};